import { render, staticRenderFns } from "./PDFViewer.vue?vue&type=template&id=7aa07adf&scoped=true&lang=pug"
import script from "./PDFViewer.vue?vue&type=script&lang=ts"
export * from "./PDFViewer.vue?vue&type=script&lang=ts"
import style0 from "./PDFViewer.vue?vue&type=style&index=0&id=7aa07adf&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa07adf",
  null
  
)

export default component.exports